import { render, staticRenderFns } from "./modalMarcas.vue?vue&type=template&id=6047b23a&scoped=true&"
import script from "./modalMarcas.vue?vue&type=script&lang=js&"
export * from "./modalMarcas.vue?vue&type=script&lang=js&"
import style0 from "./modalMarcas.vue?vue&type=style&index=0&id=6047b23a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6047b23a",
  null
  
)

export default component.exports